import { atom } from "recoil";

import { keysOfRecoil } from "store/recoil/keys";
import type { Color } from "utils/constants/colorInfo";

export const appBackgroundColorState = atom<Color>({
  key: keysOfRecoil.APP_BACKGROUND_COLOR,
  default: "gray-white",
});
